'use client'

import { AXIOS_INSTANCE as AXIOS_INSTANCE_SDK_V3 } from '@cocoonspace/api'
import { AXIOS_INSTANCE as AXIOS_INSTANCE_SDK_V1 } from '@cocoonspace/sdk-js/axios-client/use-custom-instance'
import { setupSessionCookieRefresh } from '@cocoonspace/shared/auth/session-cookie'
import { getApiConfig } from '@cocoonspace/shared/config/api.config'

import { envClient } from '~/lib/env'
import { accessTokenInterceptor } from '~/lib/interceptors/access-token.interceptor'

let didInit = false

export const initClientSdks = () => {
	if (didInit) return
	didInit = true

	const apiConfig = getApiConfig(envClient.NEXT_PUBLIC_APP_ENV)

	AXIOS_INSTANCE_SDK_V1.defaults.baseURL = apiConfig.v1BaseUrl
	AXIOS_INSTANCE_SDK_V3.defaults.baseURL = apiConfig.v3BaseUrl

	// Interceptors
	AXIOS_INSTANCE_SDK_V1.interceptors.request.use(accessTokenInterceptor)
	AXIOS_INSTANCE_SDK_V3.interceptors.request.use(accessTokenInterceptor)

	setupSessionCookieRefresh()
}
